// extracted by mini-css-extract-plugin
export default {"container":"HeaderTop_container__XDioK","instaLogo":"HeaderTop_instaLogo__KPKLl","instaContainer":"HeaderTop_instaContainer__u13qb"};